import * as ROUTES from '#client/constants/routes';

export function isAccessedFromVeloChat() {
  if (typeof window === 'undefined' || !document.referrer) {
    return false;
  }

  try {
    return new URL(document.referrer).pathname.startsWith(ROUTES.VELO_GUIDE);
  } catch {
    return false;
  }
}
